
import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2024 Quipo Software Pvt. Ltd.</p>
    </footer>
  );
};

export default Footer;